import { DataFlow, ItemDataFlow } from 'models/DataFlow'
import { Problem } from '../types/Problem'
import { t } from 'i18next'

export const checkCopyErrors = (flows: DataFlow[]): Problem[] => {
  const blocks: ItemDataFlow[] = flows.flatMap((flow) => Object.values(flow))

  return blocks
    .filter((block) => {
      return block.data?.name.includes('<copy>')
    })
    .map((block) => {
      return {
        type: 'error',
        groupId: block.data.groupId,
        blockId: block.id,
        blockName: block.data.name,
        message: t('linter.errors.copyMessage'),
      }
    })
}
